export default __webpack_public_path__ + "static/media/no-data-available.8aa183d6.png";